import React from 'react';
import classnames from 'classnames';
import 'shared/css/icons.scss'; // TODO: replace these
import styles from './styles.mod.scss';

const SmallPrevArrow = ({ className, onClick }) => (
  <div className={classnames(className, styles.arrow)} onClick={onClick}>
    <div className={classnames('icon-arrow-left', styles.arrowIcon)} />
  </div>
);

const SmallNextArrow = ({ className, onClick }) => (
  <div className={classnames(className, styles.arrow)} onClick={onClick}>
    <div className={classnames('icon-arrow-right', styles.arrowIcon)} />
  </div>
);

const PrevArrow = ({ className, ...rest }) => (
  <SmallPrevArrow
    className={classnames(className, styles.largeArrow)}
    {...rest}
  />
);

const NextArrow = ({ className, ...rest }) => (
  <SmallNextArrow
    className={classnames(className, styles.largeArrow)}
    {...rest}
  />
);

export { PrevArrow, NextArrow, SmallPrevArrow, SmallNextArrow };
